export const iconFontAwesomeAlphabetG = (
	<i className="fa-solid fa-g"></i>
);
